import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SiteService } from '../../services/context-discovery/site.service';
import { EventBusService } from '../../services/shared/event-bus.service';
import { HistoryValidationService } from '../../../../context-discovery-services/services/history-validation.service';
import { CdtStatus } from '../../../cdt-status';
import { PollingService } from '../../services/context-discovery/polling.service';
import { environment } from '../../../../environments/environment';
import { StatusResolver } from '../../../../context-discovery-services/util';
import { HistoryConfigStatus } from '../../../../context-discovery-services/enums/history-config-status';
import { LaunchDarklyService } from '../../../../context-discovery-services/services';
import { FeatureFlags } from '../../../../context-discovery-services/constants/feature-flags.const';
import { OrganisationSettingsService } from '../../services/organisation-settings.service';
import { Router } from '@angular/router';

@Component({
  selector: 'adminapp-upload-history-wrapper',
  templateUrl: './upload-history-wrapper.component.html',
  styleUrls: ['./upload-history-wrapper.component.scss']
})
export class UploadHistoryWrapperComponent implements OnInit {
  isContextDiscoveryIsInProgress = false;
  isHistoryValidationInProgress = false;
  isSiteData1UploadRequired = false;
  isAssetIdentificationRequired = false;
  showLoading = true;
  modelId = '';
  showNotFoundError = false;
  showAuthenticationError = false;
  showGenericError: boolean;
  isSetupAnalyticsComplete: boolean = true;
  statusResolver: StatusResolver;
  isHistoryPublishInProgress: boolean;
  historyValidationStatus: HistoryConfigStatus;
  showAssetIdentificationFailedError: boolean;
  isHistoryPublishFailed: boolean;
  isHistoryPublishCompleted: boolean;
  launchDarklySubscription: any;
  isHistoryValidationFeatureEnabled: boolean;
  isHistoryPublishFeatureEnabled: boolean;
  isAutomaticAnalyticsSetupFeatureEnabled: boolean;
  isUnifiedFlowEnabled: boolean;
  organizationId: string;
  organisationSettings = null;
  isPublishInProgress: boolean = false;
  isReloadingRequired: boolean = false;

  constructor(private siteService: SiteService, private eventBus: EventBusService, private ref: ChangeDetectorRef,
    private historyValidationService: HistoryValidationService, private ldService: LaunchDarklyService,
    private organisationSettingsService: OrganisationSettingsService, private router: Router) {
    this.organizationId = sessionStorage.getItem('organizationid');
    this.organisationSettingsService.setOrganisationId(this.organizationId);
    this.isHistoryValidationFeatureEnabled = ldService.getBooleanFeatureFlagValue(FeatureFlags.HISTORY_VALIDATION);
    this.isHistoryPublishFeatureEnabled = ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_HISTORY_DATA);
    this.isAutomaticAnalyticsSetupFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.AUTOMATIC_ANALYTICS_SETUP);
    this.isUnifiedFlowEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.UNIFIED_WORKFLOW);
    this.launchDarklySubscription = this.ldService.flagChange.subscribe(_ => {
      this.isUnifiedFlowEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.UNIFIED_WORKFLOW, true);
      const isHistoryValidationFeatureEnabled = ldService.getBooleanFeatureFlagValue(FeatureFlags.HISTORY_VALIDATION, true);
      if (isHistoryValidationFeatureEnabled !== this.isHistoryValidationFeatureEnabled) {
        this.isHistoryValidationFeatureEnabled = isHistoryValidationFeatureEnabled;
        if (isHistoryValidationFeatureEnabled) {
          this.isReloadingRequired = true;
        }
      }

      const isHistoryPublishFeatureEnabled = ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_HISTORY_DATA, true);
      if (isHistoryPublishFeatureEnabled !== this.isHistoryPublishFeatureEnabled) {
        this.isHistoryPublishFeatureEnabled = isHistoryPublishFeatureEnabled;
        if (isHistoryPublishFeatureEnabled) {
          this.isReloadingRequired = true;
        }
      }
      this.isAutomaticAnalyticsSetupFeatureEnabled
        = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.AUTOMATIC_ANALYTICS_SETUP, true);

      if (this.isReloadingRequired) {
        this.isReloadingRequired = false;
        this.showLoading = true;
        this.ngOnInit();
      }
    });

    this.statusResolver = new StatusResolver();
    this.eventBus.serverError$.subscribe((errorMessage) => {
      const uploadHistoryErrorToast: any = document.getElementById('uploadHistoryErrorToast');
      if (uploadHistoryErrorToast) {
        uploadHistoryErrorToast.text = errorMessage;
        uploadHistoryErrorToast.open();
      } else {
        console.error(errorMessage);
      }
    });
  }

  ngOnInit() {
    this.removeAllErrors();
    if (this.isHistoryValidationFeatureEnabled || this.isHistoryPublishFeatureEnabled) {

      const pollingService: PollingService = new PollingService(+environment.cdt.refreshInterval);
      pollingService.start(_ => this.siteService.getStatusFromOrganizationId(this.organizationId), statusResponse => {
        if (!this.isHistoryValidationFeatureEnabled && !this.isHistoryPublishFeatureEnabled) {
          pollingService.stop();
          return;
        }

        if (statusResponse) {
          this.isSetupAnalyticsComplete = (this.isAutomaticAnalyticsSetupFeatureEnabled
            && this.statusResolver.isSetupAnalyticsCompletedSuccessfully(statusResponse));

          const historyPublishStatus = (this.isHistoryPublishFeatureEnabled ?
            this.statusResolver.getStatusOfPublishHistory(statusResponse) : undefined);

          this.isHistoryPublishInProgress = (historyPublishStatus === CdtStatus.PUBLISH_IN_PROGRESS);
          this.isHistoryPublishFailed = (historyPublishStatus === CdtStatus.PUBLISH_FAILED);
          this.isHistoryPublishCompleted = (historyPublishStatus === CdtStatus.COMPLETED);

          this.isPublishInProgress = (this.statusResolver.getStatusOfPublishWithAutomaticAnalyticsSetup(
            this.statusResolver.getCompleteOnboardingStatus(statusResponse, this.isAutomaticAnalyticsSetupFeatureEnabled),
            this.isAutomaticAnalyticsSetupFeatureEnabled) === CdtStatus.PUBLISH_IN_PROGRESS);

          this.isContextDiscoveryIsInProgress = false;
          this.showAssetIdentificationFailedError = false;
          this.isAssetIdentificationRequired = false;
          this.isSiteData1UploadRequired = false;
          this.showLoading = true;
          if (this.isPublishInProgress) {
            this.removeAllErrors();
            this.showLoading = false;
            this.ref.detectChanges();
          } else {
            switch (statusResponse.Status) {
              case CdtStatus.COMPLETED:
              case CdtStatus.PUBLISH_FAILED:
                this.siteService.getModelId(this.organizationId).subscribe(modelIdResponse => {
                  this.removeAllErrors();
                  this.showLoading = false;
                  this.ref.detectChanges();
                  pollingService.stop();
                  this.checkSiteDataUploadRequiredAndShowView(modelIdResponse);
                  if (this.isHistoryPublishInProgress) {
                    this.modelId = modelIdResponse;
                    this.onHistoryPublishStarted();
                  }
                  if (this.isHistoryValidationFeatureEnabled) {
                    this.historyValidationService.getValidateHistoryStatus().subscribe(statusResponse => {
                      if (this.modelId !== modelIdResponse && !this.isHistoryPublishInProgress) {
                        this.modelId = modelIdResponse;
                      }
                      switch (statusResponse.Status) {
                        case HistoryConfigStatus.VALIDATION_IN_PROGRESS: this.onHistoryValidationStarted();
                          break;
                        default:
                          this.historyValidationStatus = statusResponse.Status;
                          this.ref.detectChanges();
                          break;
                      }
                    }, error => {
                      if (this.modelId !== modelIdResponse && !this.isHistoryPublishInProgress) {
                        this.modelId = modelIdResponse;
                      }
                      console.log(error);
                    });
                  }
                }, this.handleFailure.bind(this));
                break;
              case CdtStatus.FAILED:
                this.showLoading = false;
                this.showAssetIdentificationFailedError = true;
                pollingService.stop();
                this.ref.detectChanges();
                break;
              case CdtStatus.IN_PROGRESS:
                this.removeAllErrors();
                this.showLoading = false;
                this.isContextDiscoveryIsInProgress = true;
                this.ref.detectChanges();
                break;
            }
          }
        }
      }, ((error) => {
        console.log(error);
        this.handleFailure(error);
        pollingService.stop();
      }).bind(this));
    }
  }

  removeAllErrors() {
    this.showGenericError = false;
    this.showAuthenticationError = false;
    this.showNotFoundError = false;
    this.showAssetIdentificationFailedError = false;
  }

  showPrerequisiteStepInModelAbsence() {
    this.organisationSettingsService.getSettings().subscribe(settings => {
      this.organisationSettings = settings;

      if (!settings.PreSales || !settings.PreSales.CdtStatus) {
        this.isSiteData1UploadRequired = true;
      } else if (settings.PreSales && settings.PreSales.CdtStatus === 'NewFile') {
        this.isAssetIdentificationRequired = true;
      }
      this.ref.detectChanges();
    }, this.handleFailure.bind(this));
  }

  checkSiteDataUploadRequiredAndShowView(modelIdResponse) {
    if (modelIdResponse) {
      this.siteService.getModelPresenceStatus(modelIdResponse).subscribe(modelTtlExistenceStatus => {
        if (!modelTtlExistenceStatus) {
          this.showPrerequisiteStepInModelAbsence();
        }
      }, this.handleFailure.bind(this));
    } else {
      this.showPrerequisiteStepInModelAbsence();
    }
  }

  handleFailure(errorResponse) {
    this.removeAllErrors();
    this.showLoading = false;
    switch (errorResponse.status) {
      case 401:
        this.showAuthenticationError = true;
        break;
      case 404:
        this.showNotFoundError = true;
        break;
      default:
        this.showGenericError = true;
    }
    this.ref.detectChanges();
  }

  showLayout() {
    return this.modelId !== '' || this.isContextDiscoveryIsInProgress || this.showAssetIdentificationFailedError
      || this.isAssetIdentificationRequired || this.isSiteData1UploadRequired || this.isPublishInProgress || this.isHistoryPublishFailed;
  }

  onHistoryValidationStarted() {
    const tempModelId = this.modelId;
    this.resetModelId();
    this.isHistoryValidationInProgress = true;
    const pollingService: PollingService = new PollingService(+environment.cdt.refreshInterval);
    pollingService.start(_ =>
      this.historyValidationService.getValidateHistoryStatus()
      , (statusResponse) => {
        switch (statusResponse.Status) {
          case HistoryConfigStatus.VALIDATION_IN_PROGRESS:
            break;
          default:
            this.historyValidationStatus = statusResponse.Status;
            this.modelId = tempModelId;
            this.isHistoryValidationInProgress = false;
            pollingService.stop(); break;
        }
      }, (error) => {
        console.log(error);
        this.modelId = tempModelId;
        this.isHistoryValidationInProgress = false;
        pollingService.stop();
      });
  }

  onHistoryPublishStarted() {
    const tempModelId = this.modelId;
    this.resetModelId();
    this.isHistoryPublishInProgress = true;
    const pollingService: PollingService = new PollingService(+environment.cdt.refreshInterval);
    pollingService.start(_ =>
      this.siteService.getStatusFromOrganizationId(this.organizationId)
      , (statusResponse) => {
        if (statusResponse) {
          const historyPublishStatus = (this.isHistoryPublishFeatureEnabled ?
            this.statusResolver.getStatusOfPublishHistory(statusResponse) : undefined);
          this.isHistoryPublishInProgress = (historyPublishStatus === CdtStatus.PUBLISH_IN_PROGRESS);
          this.isHistoryPublishFailed = (historyPublishStatus === CdtStatus.PUBLISH_FAILED);
          this.isHistoryPublishCompleted = (historyPublishStatus === CdtStatus.COMPLETED);
          if (!this.isHistoryPublishInProgress) {
            this.modelId = tempModelId;
            pollingService.stop();
          }
        }
      }, (error) => {
        console.log(error);
        this.modelId = tempModelId;
        this.isHistoryPublishInProgress = false;
        this.isHistoryPublishFailed = false;
        this.isHistoryPublishCompleted = false;
        pollingService.stop();
      });
  }

  resetModelId() {
    this.modelId = '';
  }

  onGoToViewAssets() {
    if (this.isUnifiedFlowEnabled) {
      this.router.navigate(['asset-discovery']);
    } else {
      this.eventBus.conveyToNavigate('/identify-assets');
    }
  }
}
